import styled from 'styled-components'

export const Svg = styled.svg`
  ${props => props.svgStyle};
`



// WEBPACK FOOTER //
// ./src/app/elements/Icon/styles.js